import { ThemeEvents } from "@theme/events";
import { morph } from "@theme/morph";
import { Component } from "@theme/component";

class ProductBatchBadge extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateBadge,
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateBadge,
    );
  }

  /**
   * Updates the badge quantity when a variant is selected.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newBadge = event.detail.data.html.querySelector(
      "product-batch-badge",
    );
    if (!newBadge) return;

    morph(this, newBadge, { childrenOnly: true });
  };
}

if (!customElements.get("product-batch-badge")) {
  customElements.define("product-batch-badge", ProductBatchBadge);
}
